import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CityModel } from '../../../../models/city.model';
import { StateModel } from '../../../../models/state.model';
import { CityService } from '../../../../services/city.service';
import { StateService } from '../../../../services/state.service';
import { finalize } from 'rxjs';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    standalone: true,
    imports:[FormsModule,NgIf,NgForOf],
    providers:[StateService,CityService],
    selector: 'city-form',
    templateUrl: './city-form.component.html',
    styleUrls: ['./city-form.component.css']
})

export class CityFormComponent implements OnInit {
    states!: StateModel[];
    city!: CityModel;
    had!: string;
    errors!: string;
    isRequesting: boolean = false;

    constructor(private stateService: StateService, private cityService: CityService,
        private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        this.city = new CityModel();

        this.route.params.subscribe(p => {
            this.city.id = +p['id'];

            //console.log(p);

            if (this.city.id) {
                this.cityService.getCity(this.city.id).subscribe((c:any) => {
                    this.city = c;
                    this.had = 'Edit City';
                });
            }

            else {                
                this.city.id = 0;
                this.had = 'New City';
            }

        });


        this.stateService.getStates().subscribe((s:any) => {
            this.states = s;
        });

    }

    submit() {

        if (this.city.id) {
            this.isRequesting = true;
            this.errors = '';
            this.cityService.update(this.city)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe((c:any) => {
                this.router.navigate(['/admin/city/index']);
            },
                (errors : any) => this.errors = errors);
        }

        else {
            this.isRequesting = true;
            this.errors = '';
            this.cityService.create(this.city)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe((c:any) => {
                this.router.navigate(['/admin/city/index']);
            },
                (errors:any) => this.errors = errors);
        }
    }
}
